export const ABOUT_CONSTS = {
    SET_ABOUT_DATA:"SET_ABOUT_DATA",
};
